import http from './http'

export default {
  basis: {
    getAllMenus () {
      return http.get('/system/basis/getallmenus')
    },
    getPayTypeList () {
      return http.get('/system/basis/getpaytypelist')
    },
    getModuleTypeList () {
      return http.get('/system/basis/getmoduletypelist')
    }
  },
  config: {
    get (code) {
      return http.get('/system/config/get', code)
    },
    getList () {
      return http.get('/system/config/getlist')
    },
    batchUpdate (models) {
      return http.post('/system/config/batchupdate', models)
    },
    update (model) {
      return http.post('/system/config/update', model)
    }
  },
  article: {
    getArticle (code) {
      return http.get('/system/article/getarticle', {code: code})
    },
    getArticleInfo (id) {
      return http.get('/system/article/getarticleinfo', {id: id})
    },
    getArticleInfoList (code) {
      return http.get('/system/article/getarticleinfolist', {code: code})
    },
    create (model) {
      return http.post('/system/article/createarticleinfo', model)
    },
    update (model) {
      return http.post('/system/article/updatearticleinfo', model)
    },
    delete (id) {
      return http.post('/system/article/deletearticleinfo', id)
    }
  },
  merchantScreenSetting: {
    get () {
      return http.get('/system/merchantscreensetting/get')
    },
    createOrUpdate (model) {
      return http.post('/system/merchantscreensetting/createorupdate', model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/system.js